var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClaim = function SvgClaim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F8F9FA",
    rx: 40
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#claim_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "M37.4 27.814a11.586 11.586 0 0 1 22.411 4.12A11.583 11.583 0 0 1 41.16 41.11a10.53 10.53 0 0 0-3.76-13.295",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    fillRule: "evenodd",
    d: "M48.037 28.372c-.786-.086-1.9-.68-1.9-2.03 0-1.462 1.314-2.033 2.094-2.033q.105.001.2.011c.786.086 1.903.677 1.903 2.026 0 1.463-1.317 2.034-2.097 2.034q-.1 0-.2-.011zm.194 2.485c.986 0 1.786.8 1.786 1.789v5.128a1.786 1.786 0 1 1-3.571 0v-5.128c0-.986.8-1.786 1.785-1.786z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    d: "M31.614 43.597a6.97 6.97 0 0 0 5.02-11.949 6.971 6.971 0 1 0-5.02 11.95M20 57.535a11.614 11.614 0 1 1 23.229 0 1.163 1.163 0 0 1-1.16 1.162H21.163A1.163 1.163 0 0 1 20 57.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    fillRule: "evenodd",
    d: "M20.057 57.754a2.143 2.143 0 0 1 2.143-2.142h35.606a2.143 2.143 0 1 1 0 4.285H22.2a2.143 2.143 0 0 1-2.143-2.143",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "claim_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 20h40v40H20z"
  })))));
};
export default SvgClaim;